export class Property {
    _value;
    listeners = new Set();
    constructor(initial) {
        this._value = initial;
    }
    get value() {
        return this._value;
    }
    set value(next) {
        if (Object.is(next, this._value))
            return;
        const prev = this._value;
        this._value = next;
        for (const fn of this.listeners)
            fn(next, prev);
    }
    /** Subscribe and immediately invoke with current value. */
    link(fn) {
        fn(this._value, this._value);
        return this.subscribe(fn);
    }
    /** Subscribe; returns an unsubscribe handle. */
    subscribe(fn) {
        this.listeners.add(fn);
        return () => {
            this.listeners.delete(fn);
        };
    }
    /** Computed property derived from this one. */
    derived(map) {
        const out = new Property(map(this._value));
        this.subscribe((v) => {
            out.value = map(v);
        });
        return out;
    }
}
